import {
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faSpinnerThird,
  faTriangleExclamation
} from '@fortawesome/pro-solid-svg-icons'
import type { IconDefinition } from '@fortawesome/pro-solid-svg-icons'

export interface MessageConfig {
  icon: IconDefinition
  colorToken:
    | 'colorInfo'
    | 'colorSuccess'
    | 'colorError'
    | 'colorWarning'
    | 'colorPrimary'
}

export const MESSAGE_CONFIG = {
  info: {
    icon: faCircleInfo,
    colorToken: 'colorInfo'
  },
  success: {
    icon: faCircleCheck,
    colorToken: 'colorSuccess'
  },
  error: {
    icon: faCircleExclamation,
    colorToken: 'colorError'
  },
  warning: {
    icon: faTriangleExclamation,
    colorToken: 'colorWarning'
  },
  loading: {
    icon: faSpinnerThird,
    colorToken: 'colorPrimary'
  }
} as const satisfies Record<string, MessageConfig>

export type MessageStatus = keyof typeof MESSAGE_CONFIG
